"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactDom = require("react-dom");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _glamor = require("glamor");

var _recompose = require("recompose");

var _reactRouter = require("react-router");

var _Hr = require("@quixeltools/quixel-ui-library/dist/components/common/website/Hr");

var _Hr2 = _interopRequireDefault(_Hr);

var _MenuIcon = require("@quixeltools/quixel-ui-library/dist/components/common/website/MenuIcon");

var _MenuIcon2 = _interopRequireDefault(_MenuIcon);

var _DropdownMenu = require("@quixeltools/quixel-ui-library/dist/components/common/website/DropdownMenu");

var _DropdownMenu2 = _interopRequireDefault(_DropdownMenu);

var _components = require("components");

var _css = require("@quixeltools/quixel-ui-library/dist/utils/css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var header = function header(open) {
  return (0, _glamor.css)({
    width: "100%",
    height: "5em",
    background: "rgba(0,0,0,0)", //open ? '#000' : 'rgba(0,0,0,0)',
    touchAction: "none",
    position: "fixed",
    zIndex: 12
  }, (0, _css.maxWidth)("3240px")({
    height: "3.75em"
  }));
};

var headerInner = (0, _glamor.css)({
  width: "100%",
  height: "100%",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center"
});

var logoWrap = (0, _glamor.css)({
  flexGrow: 1
});

var logo = (0, _glamor.css)({
  display: "inline-block",
  width: "4.5vw",
  marginTop: "0.2vw",
  marginLeft: "0.75vw"
}, (0, _css.maxWidth)(_css.breakpoints.xxlarge)({
  marginLeft: "1vw",
  width: "5.5vw"
}, (0, _css.maxWidth)(_css.breakpoints.xlarge)({
  marginLeft: "1.2vw",
  width: "6.5vw"
}), (0, _css.maxWidth)(_css.breakpoints.large)({
  marginLeft: "1.5vw",
  width: "7.5vw"
}), (0, _css.maxWidth)(_css.breakpoints.mediumlarge)({
  marginLeft: "2vw",
  width: "3.5vw"
})), (0, _css.maxWidth)(_css.breakpoints.mediumSmall)({
  marginLeft: "2vw",
  width: "4.5vw"
}), (0, _css.maxWidth)(_css.breakpoints.small)({
  width: "5.5vw",
  marginLeft: "3vw"
}));

var nav = (0, _glamor.css)({
  width: "100%",
  height: "100%",
  // overflow: 'hidden',
  display: "inline-block",
  verticalAlign: "middle",
  marginRight: "1vw"
});
var linksContainer = (0, _glamor.css)({
  width: "100%",
  overflowY: "auto",
  flexDirection: "column",
  height: "100%",
  paddingBottom: "3rem",
  display: "flex"
}, (0, _css.minWidth)(_css.breakpoints.mediumlarge)({
  width: "unset",
  overflowY: "unset",
  flexDirection: "unset",
  height: "unset",
  paddingBottom: "unset"
}), _css.noListStyle);

var linkWrap = function linkWrap(label, flag, mobileOnly) {
  return (0, _glamor.css)({
    // paddingTop: unitRem(0.4375),
    // paddingBottom: unitRem(0.4375),
    // borderTop: `1px solid ${colors.medLightGray}`,
    display: "inline-flex",
    // opacity:flag?'1':'0.6',
    width: "100%",
    margin: "0 0.5vw",
    // '& a':{
    //   fontWeight:'700!important',
    // },
    // '&:first-child': {
    // marginRight: '0.8rem',
    // },
    // '&:nth-child(2)': {
    // marginRight: '0.8rem',
    // },

    "&:last-child": {
      borderBottom: "1px solid " + _css.colors.medLightGray
    }
    // '&:hover':{
    //   opacity:'1'
    // }
  }, (0, _css.minWidth)(_css.breakpoints.mediumlarge)({
    //display: label === 'Logout' || label === 'Login' ? 'none' :'inline-block',
    display: mobileOnly ? "none" : "inline-flex",
    border: "none !important",
    width: "unset"
  })
  // , polyfluid({
  //   marginLeft: {
  //     mediumLarge: [0, 2],
  //   },
  // })
  );
};

var subMenuLi = function subMenuLi(label, flag) {
  return (0, _glamor.css)({
    width: "100%",
    padding: "1.1em",
    paddingTop: "0.15em",
    paddingBottom: "0.15em",
    borderTop: "1px solid " + _css.colors.medLightGray,
    // paddingLeft:'1.14rem',
    margin: 0,
    cursor: "pointer",
    display: "inline-flex",
    opacity: flag ? "1" : "0.6",
    letterSpacing: "0.75px",

    "& a": {
      fontSize: "0.9375rem !important",
      letterSpacing: "0.5px"
    },
    "&:hover": {
      opacity: "1",
      background: _css.pallets.lightGray_hightlight,
      transition: "background " + _css.time.fast + " ease-out",
      "& a": {
        color: "white"
      }
    }
  }, (0, _css.minWidth)(_css.breakpoints.mediumlarge)({
    //display: label === 'Logout' || label === 'Login' ? 'none' :'inline-block',
    display: label === "Logout" || label === "Login" ? "inline-flex" : "inline-flex",
    border: "none !important"
  }));
};

var subMenuOfSubMenuLi = function subMenuOfSubMenuLi(label, flag, icon) {
  return (0, _glamor.css)({
    width: "100%",
    padding: "1.1em",
    paddingTop: "0.15em",
    paddingBottom: "0.15em",
    borderTop: "1px solid " + _css.colors.medLightGray,
    // paddingLeft:'1.14rem',
    margin: 0,
    cursor: "pointer",
    display: "inline-flex",
    alignItems: "center",
    opacity: flag ? "1" : "0.6",
    letterSpacing: "0.75px",
    paddingLeft: icon ? "3.87rem" : "4.8rem",
    "& a": {
      fontSize: "0.9375rem !important",
      letterSpacing: "0.5px!important"
      // fontWeight:'400!important',
      // textTransform:'capitalize'
    },
    "&:hover": {
      opacity: "1",
      background: _css.pallets.lightGray_hightlight,
      transition: "background " + _css.time.fast + " ease-out",
      "& a": {
        color: "white"
      },
      "& div": {
        transition: "border " + _css.time.fast + " ease-out",
        borderTop: "2px solid " + _css.pallets.white,
        borderRight: "2px solid " + _css.pallets.white
      }
    }
  }, (0, _css.minWidth)(_css.breakpoints.mediumlarge)({
    //display: label === 'Logout' || label === 'Login' ? 'none' :'inline-block',
    display: label === "Logout" || label === "Login" ? "inline-flex" : "inline-flex",
    border: "none !important"
  }));
};

var _hr = (0, _glamor.css)({
  marginTop: "0.9rem",
  marginBottom: "0.9rem",
  borderTopWidth: 2
}, (0, _css.maxWidth)(_css.breakpoints.mediumlarge)({
  display: "none"
}));
//
// const menuWrap = css({
//   display: 'none',
// }, minWidth(breakpoints.mediumlarge)({
//   display: 'inline-block',
//   verticalAlign: 'middle',
//   marginLeft: '1.5em',
// }))

var menuWrap = (0, _glamor.css)({
  display: "none",
  marginRight: "1vw"
  // '& span':{
  //   display: 'inline-block',
  // },
  // '& a':{
  //   fontSize: '1.35em !important',
  //   padding: '0.2vw 1vw 0.25vw',
  // }
}, (0, _css.minWidth)(_css.breakpoints.mediumlarge)({
  display: "inline-block",
  verticalAlign: "middle"
  // marginLeft: '1.5em',
})
// ,maxWidth('3840px')({
//   '& button':{
//     fontSize: '1.125em !important',
//   },
//   '& a':{
//     fontSize: '1.125em !important',
//   },
// }),maxWidth('3240px')({
//   '& button':{
//     fontSize: '0.9em !important',
//   },
//   '& a':{
//     fontSize: '0.9em !important',
//   },})
);

var desktopLogo = (0, _glamor.css)({
  display: "none"
}, (0, _css.minWidth)(_css.breakpoints.mediumlarge)({
  display: "inline-block"
}));

var mobileLogo = (0, _glamor.css)({
  display: "inline-block"
}, (0, _css.minWidth)(_css.breakpoints.mediumlarge)({
  display: "none"
}));
var logoImg = (0, _glamor.css)({
  display: "inline-flex",
  height: "20px",
  width: "20px",
  margin: "auto",
  marginRight: "12px",
  marginLeft: "6px"
});

var navWrap = function navWrap(open) {
  return (0, _glamor.css)({
    visibility: open ? "visible" : "hidden",
    position: "absolute",
    marginTop: -1,
    top: "3.75em",
    left: 0,
    right: 0,
    paddingTop: open ? (0, _css.unitRem)(1.6) : 0,
    paddingBottom: open ? (0, _css.unitRem)(2) : 0,
    paddingLeft: (0, _css.unitRem)(1),
    paddingRight: (0, _css.unitRem)(1),
    height: open ? "100vh" : 0,
    opacity: open ? 1 : 0,
    transition: "height " + _css.time.fast + ", visibility " + _css.time.fast + ", padding " + _css.time.fast + ", opacity " + _css.time.fast,
    background: _css.colors.black
  }, (0, _css.minWidth)(_css.breakpoints.mediumlarge)({
    display: "block",
    alignSelf: "initial",
    marginTop: 0,
    // marginRight: '2.5vw',
    padding: 0,
    opacity: 1,
    height: "auto",
    visibility: "visible",
    background: "none",
    position: "static"
  }));
};
var textButton = function textButton(flag) {
  return (0, _glamor.css)({
    display: "block",
    width: "100%",
    textAlign: "left",
    textTransform: "none",
    transition: "transform " + _css.time.fast + ", text-shadow " + _css.time.fast,
    color: "#fff",
    fontWeight: 700,
    paddingTop: 0,
    paddingBottom: 0,
    // fontSize: '0.55vw !important',
    "& button": {
      fontWeight: 700,
      // height: 38, //different for buttons and 'a' tags in safari
      lineHeight: "38px",
      fontSize: "0.9375rem !important",
      padding: "0.28vw 0.24vw",
      letterSpacing: "0.5px"
    },
    "& a": {
      fontWeight: 700,
      // height: 38, //different for buttons and 'a' tags in safari
      lineHeight: "38px",

      padding: "0.28vw 0.24vw",
      fontSize: "0.9375rem !important",
      letterSpacing: "0.5px"
    },
    "&:hover": {
      transform: "translateY(-1px)",
      // textShadow: '0 6px 18px rgba(0,0,0,0.55)',
      color: "#fff"
    }
  }, (0, _css.minWidth)(_css.breakpoints.mediumlarge)({
    width: "auto",
    textAlign: "center",
    textTransform: "uppercase"
  }), (0, _css.maxWidth)("3840px")({
    "& button": {
      fontSize: "0.9375rem !important"
    },
    "& a": {
      fontSize: "0.9375rem !important"
    }
  }), (0, _css.maxWidth)("3240px")({
    "& button": {
      fontSize: "0.9375rem !important"
    },
    "& a": {
      fontSize: "0.9375rem !important"
    }
  }));
};
var _textButton = function _textButton(flag) {
  return (0, _glamor.css)({
    display: "block",
    width: "100% !important",
    height: "100% !important",
    textAlign: "left !important",
    textTransform: "uppercase",
    fontSize: "1.5em",
    "& button": {
      fontWeight: 700,
      fontSize: "0.9375rem !important",
      letterSpacing: "0.5px"
    },
    "& a": {
      fontWeight: 700,
      fontSize: "0.9375rem !important",
      letterSpacing: "0.5px"
    }
  }, (0, _css.minWidth)(_css.breakpoints.mediumlarge)({
    width: "auto",
    textAlign: "center",
    textTransform: "uppercase",
    fontWeight: 700
  }), (0, _css.maxWidth)("3840px")({
    fontSize: "0.9375rem !important"
  }), (0, _css.maxWidth)("3240px")({
    fontSize: "0.9375rem !important"
  }));
};

var menuButton = (0, _glamor.css)(_css.btnReset, {
  padding: "1.5rem",
  display: "block"
}, (0, _css.minWidth)(_css.breakpoints.mediumlarge)({
  display: "none"
}));

var ignoreEvent = function ignoreEvent(e, isOpen) {
  if (isOpen) {
    e.preventDefault();
    e.stopPropagation();
  }
};

var subMenu = function subMenu(flag) {
  return (0, _glamor.css)({
    position: "absolute",
    display: flag ? "none" : "flex",
    flexDirection: "column",
    width: "20em",
    boxShadow: " 0px 25px 100px 0 rgba(0, 0, 0, 0.25)",
    background: _css.colors.medDarkGray,
    zIndex: "1",
    "& .arrow": {
      position: "absolute",
      top: "-10px",
      left: "calc(50% - 15px)",
      width: "20px",
      height: "20px",
      background: "#252525",
      transform: "rotate(45deg)",
      zIndex: "-1"
    }
  }, (0, _css.maxWidth)(_css.breakpoints.super4k)({
    marginLeft: "-7em",
    width: "24em"
  }), (0, _css.maxWidth)(_css.breakpoints.xxxlarge)({
    width: "24em",
    marginLeft: "-7em"
  }), (0, _css.maxWidth)("3240px")({
    marginLeft: "-6em",
    width: "20em"
  }), (0, _css.maxWidth)(_css.breakpoints.xxlarge)({
    marginLeft: "-6.6em",
    width: "20em"
  }), (0, _css.maxWidth)(_css.breakpoints.xlarge)({
    marginLeft: "-6.6em"
  }), (0, _css.maxWidth)(_css.breakpoints.large)({
    marginLeft: "-6.6em"
  }), (0, _css.maxWidth)(_css.breakpoints.mediumlarge)({
    display: "flex",
    position: "initial",
    background: "none",
    width: "100%",
    marginLeft: "unset",
    transform: "unset"
  }));
};
var button = (0, _glamor.css)({
  width: "100%",
  margin: "auto",
  marginTop: "2em",
  marginBottom: "2em",
  "& button": {
    width: "98%"
  },
  "& a": {
    width: "98%"
  }
});

var SiteHeader = function (_React$Component) {
  (0, _inherits3.default)(SiteHeader, _React$Component);

  function SiteHeader(props) {
    (0, _classCallCheck3.default)(this, SiteHeader);

    var _this = (0, _possibleConstructorReturn3.default)(this, (SiteHeader.__proto__ || (0, _getPrototypeOf2.default)(SiteHeader)).call(this, props));

    _this.handleClickOutside = function (event) {
      var domNode = _reactDom2.default.findDOMNode(_this);

      if (!domNode || !domNode.contains(event.target)) {
        _this.props.setDropdown(false);
      }
    };

    _this.renderList = function (submenu, isheaderLink) {
      return submenu.map(function (_ref, i) {
        var to = _ref.to,
            img = _ref.img,
            href = _ref.href,
            label = _ref.label,
            onClick = _ref.onClick,
            submenu = _ref.submenu,
            hr = _ref.hr,
            newWindow = _ref.newWindow;
        return _react2.default.createElement(
          "div",
          { onBlur: _this.handleClickOutside, key: i },
          hr && _react2.default.createElement(_Hr2.default, { mode: "dark", className: _hr }),
          _react2.default.createElement(
            "li",
            { // eslint-disable-line jsx-a11y/no-static-element-interactions
              className: subMenuLi(label, true),
              key: i,
              onClick: onClick
            },
            img && _react2.default.createElement("img", { src: img, className: logoImg }),
            _react2.default.createElement(_components.TextButtonLibrary, {
              mode: "normal",
              to: to,
              href: href,
              label: label,
              newWindow: newWindow,
              className: _textButton(isheaderLink)
            })
          ),
          submenu && submenu.map(function (_ref2, index) {
            var to = _ref2.to,
                img = _ref2.img,
                icon = _ref2.icon,
                href = _ref2.href,
                label = _ref2.label,
                onClick = _ref2.onClick,
                submenu = _ref2.submenu,
                hr = _ref2.hr,
                newWindow = _ref2.newWindow;
            return _react2.default.createElement(
              "li",
              { // eslint-disable-line jsx-a11y/no-static-element-interactions
                className: (0, _glamor.css)(subMenuOfSubMenuLi(label, true, img || icon)),
                key: index,
                onClick: onClick
              },
              img && _react2.default.createElement("img", { src: img, className: logoImg }),
              icon && _react2.default.createElement("div", {
                className: (0, _glamor.css)({
                  width: "0.7vw",
                  height: "0.7vw",
                  marginRight: "2px",
                  minWidth: "0.7em",
                  minHeight: "0.7em",
                  borderTop: "2px solid " + _css.pallets.blue_primary,
                  borderRight: "2px solid " + _css.pallets.blue_primary,
                  transform: "rotate(45deg)",
                  transition: "border " + _css.time.fast + " ease-out"
                }, (0, _css.minWidth)(_css.breakpoints.xxlarge)({
                  width: "0.5em",
                  height: "0.5em"
                }))
              }),
              _react2.default.createElement(_components.TextButtonLibrary, {
                mode: "normal",
                to: to,
                href: href,
                label: label,
                newWindow: newWindow,
                className: _textButton(isheaderLink)
              })
            );
          })
        );
      });
    };

    _this.state = {
      transition: false
    };

    _this.handleClickOutside = _this.handleClickOutside.bind(_this);
    _this.onScroll = _this.onScroll.bind(_this);
    _this.previousOpacity;
    return _this;
  }

  (0, _createClass3.default)(SiteHeader, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener("click", this.handleClickOutside, true);
      window.removeEventListener("scroll", this.onScroll);
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener("click", this.handleClickOutside, true);
      this.elem = document.getElementById("header");
      window.addEventListener("scroll", this.onScroll);

      var isheaderLink = false;
      var props = this.props;
      var pathName = props.location.pathname;
      var isLibrary = pathName.indexOf("/megascans/library") !== -1;
      props.links.map(function (_ref3) {
        var to = _ref3.to,
            img = _ref3.img,
            href = _ref3.href,
            label = _ref3.label,
            onClick = _ref3.onClick;

        if (to) {
          var str = typeof to === "string" ? to.indexOf("library") != -1 ? "library" : to : to.pathname || href;
          if (pathName.indexOf(str) != -1) {
            isheaderLink = true;
          }
        }
      });
      this.setState({ isheaderLink: isheaderLink, isLibrary: isLibrary });
    }
  }, {
    key: "onScroll",
    value: function onScroll() {
      if (!this.state.isLibrary && window.innerWidth > 879) {
        var scrollY = window.scrollY;
        var opacity = (scrollY - 100) / 200;
        opacity = opacity < 0 ? 0 : opacity < 0.9 ? opacity : 0.9;
        if (this.previousOpacity != opacity) {
          this.previousOpacity = opacity;
          this.elem.style.backgroundColor = "rgba(0,0,0," + opacity + ")";
        }
      } else {
        this.elem.style.backgroundColor = "rgba(0,0,0,1)";
      }
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(newProps) {
      var pathName = newProps.location.pathname;
      var isLibrary = pathName.indexOf("/megascans/library") !== -1;
      this.setState({ isLibrary: isLibrary });
      this.onScroll();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var props = this.props;
      var isheaderLink = this.state.isheaderLink;


      return _react2.default.createElement(
        "header",
        {
          id: "header",
          className: header(
          // eslint-disable-next-line react/prop-types
          props.open),
          onWheel: function onWheel(e) {
            return ignoreEvent(e, props.open);
          },
          onDrag: function onDrag(e) {
            return ignoreEvent(e, props.open);
          },
          onScroll: function onScroll(e) {
            return ignoreEvent(e, props.open);
          }
        },
        _react2.default.createElement(
          "div",
          {
            className: headerInner,
            style:
            // eslint-disable-next-line react/prop-types
            this.state.isLibrary ? { background: "#000" } : {}
          },
          _react2.default.createElement(
            "div",
            { className: logoWrap },
            _react2.default.createElement(
              _reactRouter.Link,
              { to: props.logoTo },
              _react2.default.createElement("img", {
                alt: props.logoAlt,
                src: props.logoUrl,
                className: (0, _glamor.css)(logo, desktopLogo)
              }),
              _react2.default.createElement("img", {
                className: (0, _glamor.css)(logo, mobileLogo),
                onClick: function onClick() {
                  return props.open ? props.setOpen(
                  // eslint-disable-line react/prop-types
                  !props.open // eslint-disable-line react/prop-types
                  ) : null;
                },
                alt: props.logoAlt,
                src: props.logoSmallUrl
              })
            )
          ),
          _react2.default.createElement(
            "div",
            { className: navWrap(props.open) },
            _react2.default.createElement(
              "nav",
              { className: nav },
              _react2.default.createElement(
                "ul",
                { className: linksContainer },
                props.links.map(function (_ref4) {
                  var to = _ref4.to,
                      img = _ref4.img,
                      href = _ref4.href,
                      label = _ref4.label,
                      onClick = _ref4.onClick,
                      submenu = _ref4.submenu,
                      onMouseOver = _ref4.onMouseOver,
                      onMouseOut = _ref4.onMouseOut,
                      isOpen = _ref4.isOpen,
                      mobileOnly = _ref4.mobileOnly,
                      isButton = _ref4.isButton;

                  return _react2.default.createElement(
                    "div",
                    {
                      key: label // @TODO: Use some other key
                      , className: (0, _glamor.css)({ position: "static" }, (0, _css.maxWidth)(_css.breakpoints.mediumlarge)({
                        ":last-child": {
                          marginBottom: "9.5rem"
                        }
                      })),
                      onMouseOver: onMouseOver,
                      onMouseOut: onMouseOut
                    },
                    _react2.default.createElement(
                      "li",
                      { // eslint-disable-line jsx-a11y/no-static-element-interactions
                        className: linkWrap(label, true, mobileOnly),
                        key: label,
                        onClick: function onClick() {
                          return submenu !== "undefined" && props.setOpen(
                          // eslint-disable-line react/prop-types
                          false // eslint-disable-line react/prop-types
                          );
                        }
                      },
                      img && _react2.default.createElement("img", {
                        alt: props.logoAlt,
                        src: img,
                        className: logoImg
                      }),
                      isButton ? _react2.default.createElement(_components.ButtonLibrary, {
                        className: button,
                        to: to,
                        mode: "secondary",
                        label: label
                      }) : typeof submenu !== "undefined" ? _react2.default.createElement(_DropdownMenu2.default, {
                        menus: [{
                          align: "center",
                          labelClassName: textButton(false),
                          dropdown: _this2.renderList(submenu, isheaderLink),
                          onMouseEnter: true,
                          label: label,
                          labelTo: to,
                          mobileView: true
                        }]
                      }) : _react2.default.createElement(_components.TextButtonLibrary, {
                        mode: "white",
                        to: to,
                        href: href,
                        label: label,
                        onClick: onClick,
                        className: textButton(isheaderLink)
                      })
                    )
                  );
                })
              )
            )
          ),
          _react2.default.createElement(
            "div",
            null,
            _react2.default.createElement(
              "div",
              { className: menuWrap },
              props.menu
            ),
            _react2.default.createElement(
              "button",
              {
                className: menuButton,
                onClick: function onClick() {
                  return props.setOpen(
                  // eslint-disable-line react/prop-types
                  !props.open // eslint-disable-line react/prop-types
                  );
                }
              },
              _react2.default.createElement(_MenuIcon2.default, {
                open:
                // eslint-disable-next-line react/prop-types
                props.open
              })
            )
          )
        )
      );
    }
  }]);
  return SiteHeader;
}(_react2.default.Component);

exports.default = (0, _recompose.compose)((0, _recompose.withState)("open", "setOpen", false))(SiteHeader);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Library/SiteHeader.jsx
// module id = 2868
// module chunks = 0